import angular from 'angular';
import _ from 'lodash';


(function() {
    'use strict';
    angular.module('app.core').factory('registrationRequestDA', registrationRequestDA);

    registrationRequestDA.$inject = ['Restangular',  'CONF' , '$http','RegistrationRequest','$q' ,'DateService'];

    /* @ngInject */
    function registrationRequestDA(Restangular, CONF ,$http ,RegistrationRequest ,$q ,DateService ) {
        var version = 'v1';
        var baseUrl = 'registration-request';
        var FileSaver = require('file-saver');



        var exports = {
            getRegistrationRequest: getRegistrationRequest,
            getRegistrationRequestList: getRegistrationRequestList,
            searchRegistrationCompanies:searchRegistrationCompanies,
            getRegistrationRequestExport:getRegistrationRequestExport,
        };

        return exports;

        ////////////////




        /**
         * Récupere les préinscriptions  .
         */
        function getRegistrationRequestList(registrationRequestFilter) {

            return Restangular.oneUrl(CONF.apiBaseUrl)
                .oneUrl(version)
                .one(baseUrl)
                .all('registrations-list')
                .post(registrationRequestFilter)
                .then(function (pageRegistrationRequest) {
                    return{    
                        totalItems: pageRegistrationRequest.totalElements,
                        registrations: _.map(pageRegistrationRequest.content, function (r) {
                        return new RegistrationRequest(r);
                    }),
                     }
                });
        }

         /**
         * Récupere les détails de la préinscription.
         */
          function getRegistrationRequest(id) {
            return Restangular.oneUrl(CONF.apiBaseUrl)
            .oneUrl(version)
            .one(baseUrl+'/registration-detail/'+ id)
            .get()
            .then(function (data) {
                return new RegistrationRequest(data);
            });
        }

        /**
         * Récupere l'export des préinscriptions en format csv .
         */
        function getRegistrationRequestExport(registrationRequestFilter) {
            var deferred = $q.defer();
            $http.post(CONF.apiContext + CONF.apiBaseUrl + '/' + version + '/'
                + baseUrl +  '/export' + '/csv  '
                , registrationRequestFilter,
                {responseType: "blob"}).then(function (data) {
                var now = new Date();
                var filename =  'EXPORT-LIST-PREREGISTRATION-' + DateService.formatAsYMD_HM(now) + '.csv';

                FileSaver.saveAs(data.data, filename);
                deferred.resolve(filename);

            }, function (data) {
                var e = /* error */
                    deferred.reject(e, data);
            });
            return deferred.promise;

        }

        /**
         * Récupere la list des company préinscris .
         */
        function searchRegistrationCompanies(value){
            return Restangular.oneUrl(CONF.apiBaseUrl)
                    .oneUrl(version)
                    .one(baseUrl)
                    .all('search-registration-companies')
                    .post({ value: value })
                    .then(function (pageSubEntities) {
                        return _.map(pageSubEntities.content, function (s) {
                            return new RegistrationRequest(s);
                        });
                    });


        }
    }
})();
